import { Dashboard, WebsiteClick } from '@onesource/icons';
import type { IconType } from 'react-icons';
import { FaDumbbell, FaGraduationCap, FaHeart, FaStar, FaUsers } from 'react-icons/fa';
import { GiLotus, GiMeditation, GiYinYang } from 'react-icons/gi';
import {
  RiApps2Line,
  RiBookOpenLine,
  RiChat1Line,
  RiCompassLine,
  RiDashboardLine,
  RiFacebookLine,
  RiFileList3Line,
  RiGroupLine,
  RiHome4Line,
  RiInstagramLine,
  RiLinkedinLine,
  RiLinksLine,
  RiStarLine,
  RiTiktokLine,
  RiYoutubeLine,
} from 'react-icons/ri';
import type { SidebarItem, SidebarSection, SocialLink } from './types';

// Map icon string names to react-icons
const iconMap: Record<string, IconType> = {
  // Generic icons
  default: GiMeditation,
  home: RiHome4Line,
  book: RiBookOpenLine,
  chat: RiChat1Line,
  list: RiFileList3Line,
  apps: RiApps2Line,
  compass: RiCompassLine,
  dashboard: RiDashboardLine,
  star: RiStarLine,
  group: RiGroupLine,
  links: RiLinksLine,
  // Fitness/wellness icons
  meditation: GiMeditation,
  lotus: GiLotus,
  yinyang: GiYinYang,
  dumbbell: FaDumbbell,
  'graduation-cap': FaGraduationCap,
  users: FaUsers,
  heart: FaHeart,
  'star-filled': FaStar,
};

/**
 * Get an icon component by name, with fallback to default
 */
export const getIconForName = (iconName: string | null | undefined): IconType => {
  if (!iconName) {
    return iconMap.default;
  }
  return iconMap[iconName.toLowerCase()] || iconMap.default;
};

// Static top section items
export const topSectionItems: SidebarItem[] = [
  {
    id: 'welcome',
    label: 'Dashboard',
    icon: Dashboard,
    path: '/',
  },
  // {
  //   id: 'dashboard',
  //   label: 'Dashboard Feed',
  //   icon: RiDashboardLine,
  //   path: '/dashboard',
  // },
];

// Static bottom section items
export const getBottomSectionItems = (onOldPanelClick: () => void): SidebarItem[] => [
  {
    id: 'classic-area',
    label: 'Classic Area',
    icon: WebsiteClick,
    onClick: onOldPanelClick,
  },
];

// Default sidebar data (used when profile is not loaded yet)
export const sidebarData: SidebarSection[] = [
  {
    id: 'top',
    items: topSectionItems,
    showDivider: true,
  },
  {
    id: 'main',
    items: [],
    showDivider: true,
  },
  {
    id: 'bottom',
    items: getBottomSectionItems(Function.prototype as () => void),
  },
];

export const socialLinks: SocialLink[] = [
  {
    id: 'instagram',
    icon: RiInstagramLine,
    url: 'https://instagram.com/',
    label: 'Instagram',
  },
  {
    id: 'tiktok',
    icon: RiTiktokLine,
    url: 'https://tiktok.com/',
    label: 'TikTok',
  },
  {
    id: 'facebook',
    icon: RiFacebookLine,
    url: 'https://facebook.com/',
    label: 'Facebook',
  },
  {
    id: 'youtube',
    icon: RiYoutubeLine,
    url: 'https://youtube.com/',
    label: 'YouTube',
  },
  {
    id: 'linkedin',
    icon: RiLinkedinLine,
    url: 'https://linkedin.com/',
    label: 'LinkedIn',
  },
];
